// recorder/utils.js
/**
 * Crea el elemento de vista (<audio> o <video>) con sus atributos esenciales.
 * - Para video: <video><source></source></video>
 * - Para audio: <audio src="..."></audio>
 */
export function createRecorderViewElement(writer, modelElement) {
    const type = modelElement.getAttribute('type') || 'audio'; // "audio" | "video"
    const src = modelElement.getAttribute('src') || '';
    const width = modelElement.getAttribute('width');
    const alignment = modelElement.getAttribute('alignment');

    let mediaElement;

    if (type === 'video') {
        // Video con <source>
        mediaElement = writer.createContainerElement('video', {
            controls: 'controls',
            controlslist: 'nodownload',
            preload: 'metadata',
            class: 'nomediaplugin',
        });

        const sourceElement = writer.createEmptyElement('source', { src });
        writer.insert(writer.createPositionAt(mediaElement, 0), sourceElement);
    } else {
        // Audio simple
        mediaElement = writer.createContainerElement('audio', {
            controls: 'controls',
            controlslist: 'nodownload',
            preload: 'metadata',
            class: 'nomediaplugin',
            src
        });
    }

    // Contenedor principal siempre <figure class="recorder">
    const attrs = { class: 'recorder' };
    if (type == 'audio') {
        attrs.class += ' recorder-audio';
    }
    const container = writer.createContainerElement('figure', attrs);

    // Insertar el media dentro del figure
    writer.insert(writer.createPositionAt(container, 0), mediaElement);

    // === Ajuste de ancho visual ===
    // Si el modelo tiene width="Original" o no tiene width definido,
    // el figure se mostrará con width:100% (visual) pero sin marcarse como resized.
    if (width === 'Original' || !width) {
        writer.setStyle('width', '100%', container);
    } else {
        writer.setStyle('width', width, container);
        writer.addClass('recorder_resized', container);
    }

    // === Aplicar alineación si existe ===
    if (alignment) {
        writer.addClass(`recorder-style-align-${alignment}`, container);
    }

    return container;
}

/**
 * Matcher para identificar recorderBlock en la vista.
 */
export function getRecorderViewElementMatcher(editor) {
    return element => {
        const isMedia = element.is('element', 'audio') || element.is('element', 'video');
        if (!isMedia || !element.hasAttribute('src')) {
            return null;
        }

        // Solo si está dentro de <figure class="recorder">
        if (!element.findAncestor('figure')?.hasClass('recorder')) {
            return null;
        }

        return { name: true, attributes: ['src'] };
    };
}

/**
 * Decide el tipo de inserción: siempre block.
 */
export function determineRecorderTypeForInsertionAtSelection() {
    return 'recorderBlock';
}
